import { Pressable, Text, View } from 'react-native';

interface FormErrorBannerProps {
  error: string | null;
  onDismiss?: () => void;
}

export function FormErrorBanner({ error, onDismiss }: FormErrorBannerProps) {
  if (!error) return null;

  return (
    <View className="flex-row items-start rounded-xl bg-red-50 dark:bg-red-900/30 px-4 py-3">
      <Text className="flex-1 text-sm text-red-600 dark:text-red-400">
        {error}
      </Text>
      {onDismiss && (
        <Pressable onPress={onDismiss} hitSlop={8} className="ml-2">
          <Text className="text-sm text-red-400 dark:text-red-500">✕</Text>
        </Pressable>
      )}
    </View>
  );
}
